import { render, staticRenderFns } from "./skrg_overview_hdr.vue?vue&type=template&id=0d4027dc&scoped=true"
import script from "./skrg_overview_hdr.vue?vue&type=script&lang=js"
export * from "./skrg_overview_hdr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4027dc",
  null
  
)

export default component.exports